import { Swiper } from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import '../../css/swiper-custom.css';

export default function resourceEntryCarousel() {
  return {
    swiper: null,
    currentIndex: 0,

    init() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    },

    initSwiper() {
      if (!this.$refs.swiper || !this.$refs.prevButton || !this.$refs.nextButton) return;

      this.swiper = new Swiper(this.$refs.swiper, {
        modules: [Navigation, A11y],

        // Ensure consistent heights
        autoHeight: false,
        watchSlidesProgress: true,

        // Responsive breakpoints - small cards (326px width)
        slidesPerView: 1.4,
        spaceBetween: 16,
        centeredSlides: false,

        breakpoints: {
          640: {
            slidesPerView: 2.2,
            spaceBetween: 20,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: false,
          },
          1280: {
            slidesPerView: 4,
            centeredSlides: false,
          }
        },

        // Navigation
        navigation: {
          nextEl: this.$refs.nextButton,
          prevEl: this.$refs.prevButton,
        },

        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
          containerMessage: 'Resource entry carousel',
          containerRoleDescriptionMessage: 'carousel',
          itemRoleDescriptionMessage: 'slide'
        },

        // Touch settings
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,

        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        // Events
        on: {
          slideChange: () => {
            this.currentIndex = this.swiper.activeIndex;
          },
          init: () => {
            this.currentIndex = 0;
          }
        }
      });
    },

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },

    get totalSlides() {
      return this.swiper ? this.swiper.slides.length : 0;
    },

    get isFirstSlide() {
      return this.currentIndex === 0;
    },

    get isLastSlide() {
      return this.currentIndex === this.totalSlides - 1;
    }
  };
}
